import React, {useState} from "react";
import "./index.scss";
import {TextField} from "features/components/text-field";
import {bool, func, string} from "prop-types";
import {__} from "services/i18n";
import Button from "features/components/button";

const CompanyProductForm = (props) => {
    const {onChange, deleteButtonEnabled, onDelete} = props;
    const [titleVal, setTitle] = useState(props.title);
    const [descriptionVal, setDescription] = useState(props.description);


    React.useEffect(() => {
        onChange({
            title: titleVal,
            description: descriptionVal
        })
    }, [onChange, titleVal, descriptionVal]);

    return <div className="company-product-form">
        <div className="form-field">
            <TextField
                type={"text"}
                value={titleVal}
                onChange={setTitle}
                placeholder={__("text-fields.product-title.placeholder")}
            />
            <Button title={""} onClick={onDelete} disabled={!deleteButtonEnabled} status={deleteButtonEnabled ? "danger" : null} type={"square"} icon={"delete"} />
        </div>
        <div className="form-field single">
            <TextField
                type={"text"}
                value={descriptionVal}
                onChange={setDescription}
                placeholder={__("text-fields.product-description.placeholder")}
            />
        </div>
    </div>
};
CompanyProductForm.propTypes = {
    title: string,
    description: string,
    onChange: func.isRequired,
    deleteButtonEnabled: bool,
    onDelete: func
};

export const CompanyProductFormBaseState = {
    title: "",
    description: ""
}

export default CompanyProductForm;